"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("../../common");
const uiSchema = {
    type: "VerticalLayout",
    elements: [
        (0, common_1.makeAppointmentUiSchema)("pastAppointment", "Visit", {
            disableFuture: true,
        }),
        {
            type: "HorizontalLayout",
            elements: [
                { type: "Control", scope: "#/properties/physicianName" },
                { type: "Control", scope: "#/properties/contactPersonAtDoctorOffice" },
            ],
        },
        {
            type: "HorizontalLayout",
            elements: [
                { type: "Control", scope: "#/properties/recertFrequency" },
                {
                    type: "Control",
                    label: "Aide Required",
                    scope: "#/properties/aideRequired",
                    options: {
                        format: "radio",
                    },
                },
            ],
        },
        {
            type: "Control",
            scope: "#/properties/frequencyForAide",
            rule: {
                effect: "SHOW",
                condition: {
                    scope: "#/properties/aideRequired",
                    schema: {
                        const: true,
                    },
                },
            },
        },
    ],
};
exports.default = uiSchema;
